import React, { createContext, useContext, useState } from 'react';
import { Location } from 'types';

export type LocationState = null | Location;

type LocationContextType = [
  location: LocationState,
  setLocation: React.Dispatch<React.SetStateAction<LocationState>>
];

// Create a new context for location state
const LocationContext = createContext<LocationContextType>([null, () => null]);

// Create a provider component for location context
export function LocationProvider({ children }: { children: React.ReactNode }) {
  // Use useState to manage the location state
  const locationState = useState<LocationState>(null);

  // Return the provider component with value set to the state and the setter function
  return (
    <LocationContext.Provider value={locationState}>
      {children}
    </LocationContext.Provider>
  );
}

// Create a custom hook to use this context
export function useLocation() {
  return useContext(LocationContext);
}
